<!-- cv简历信息表-活动-页面级 -->
<template>
  <div class='activity-container'>
    <cv-warn />
    <cv-activity-detail :lang='lang' />
  </div>
</template>

<script>
import cvWarn from './components/cv-warning'
import cvActivityDetail from './components/cv-activity-detail'
export default {
  name: '',
  components: {
    cvWarn,
    cvActivityDetail
  },
  data () {
    return {
      // 中英文
      lang: ''
    }
  },
  computed: {},
  mounted () {
    this.lang = this.$route.meta.lang
  },
  methods: {}
}
</script>
<style lang='less' scoped>
</style>
